// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-5b8841e9] {\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 40px;\n}\n[data-v-5b8841e9] .el-tabs__header {\n  margin: 0;\n}\n.content[data-v-5b8841e9] {\n  height: calc(100% - 40px);\n}", ""]);
// Exports
module.exports = exports;
